import {
  CreateCustomStyleReturn,
  createStylesContext,
  MultiStyleType,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { ThemeColors } from '~/themes/colors'
import { Breakpoint } from '~/types/ThemeTypes'

import { getDotWalkedObjectMap } from './objectUtils'

export const useCustomMultiStyleConfig = <TArray extends readonly string[]>(
  themeKey: string,
  props?: StyleThemingProps,
) => {
  return useMultiStyleConfig(themeKey, props) as MultiStyleType<TArray>
}

export const createCustomStyleContext = <TArray extends readonly string[]>(
  themeKey: string,
) => {
  return createStylesContext(themeKey) as CreateCustomStyleReturn<TArray>
}

export const createColorKeys = <TColors extends Record<string, unknown>>(
  colors: TColors,
) => {
  return getDotWalkedObjectMap(colors, 1) as TypeSwapped<
    TColors,
    ThemeColors,
    string
  >
}

export const getBreakpointValue = (breakpoint: Breakpoint) => {
  switch (breakpoint) {
    case 'sm':
      return 0
    case 'md':
      return 1
    case 'lg':
      return 2
    case 'xl':
      return 3
    case '2xl':
      return 4
    default:
      return -1
  }
}

export const breakpointOperator = {
  gt: (current: Breakpoint, target: Breakpoint) =>
    getBreakpointValue(current) > getBreakpointValue(target),
  gte: (current: Breakpoint, target: Breakpoint) =>
    getBreakpointValue(current) >= getBreakpointValue(target),
  lt: (current: Breakpoint, target: Breakpoint) =>
    getBreakpointValue(current) < getBreakpointValue(target),
  lte: (current: Breakpoint, target: Breakpoint) =>
    getBreakpointValue(current) <= getBreakpointValue(target),
  eq: (current: Breakpoint, target: Breakpoint) =>
    getBreakpointValue(current) === getBreakpointValue(target),
}
